import React from 'react';
import { MdAnalytics } from 'react-icons/md';

const AdminAnalytics = () => {
  return (
    <div className="p-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Analytics</h1>
        <p className="text-gray-600">View performance metrics and reports</p>
      </div>
      
      <div className="bg-white rounded-lg shadow p-12 text-center">
        <MdAnalytics className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-2 text-sm font-medium text-gray-900">Analytics</h3>
        <p className="mt-1 text-sm text-gray-500">Analytics functionality coming soon.</p>
      </div>
    </div>
  );
};

export default AdminAnalytics; 